/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Created by jhoel on 2/11/2019.
 */

import { Assert } from "abweb/utils/Assert";

/**
 * Utility functions that deal with randomness.
 */
export class RandomUtils {
  /**
   * Pick a "whole number" between 0 inclusive and maxInclusive.
   * This uses the term Whole Number, taken from mathematical terminology,
   * ie all non-negative integers.
   */
  static randomWholeNumber(maxInclusive) {
    // console.log(":randomPositiveNumber"); //`
    return Math.floor(Math.random() * maxInclusive + 1);
  }

  /**
   * Pick an element at random from an array and return it.
   * Expects a non-empty array.
   */
  static randomElement(arr) {
    Assert.assert(arr.length > 0);
    const pickIndex = this.randomWholeNumber(arr.length - 1);
    return arr[pickIndex];
  }
}
//# sourceMappingURL=RandomUtils.js.map
